import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, of, isObservable } from 'rxjs';
import { CanComponentDeactivate } from '../../types/auth.types';

@Injectable({ providedIn: 'root' })
export class CanExitGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> {
    if (component && component.canDeactivate) {
      const result = component.canDeactivate();
      // Normalise to Observable<boolean>
      if (isObservable(result)) {
        return result;
      }
      // Synchronous boolean
      return of(result as boolean);
    }
    return of(true);
  }
}
